require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/values.js
// module id = TmV0
// module chunks = 52